import React, {useEffect, useState} from 'react';
import Header from "./Header";
import './layout.css'
import Footer from "./Footer";

interface IProps {
    children: React.ReactElement
}

function Layout({children}: IProps) {
    const [path, setPath] = useState(window.location.pathname)

    useEffect(() => {
        let loc = window.location.pathname.split('/')
        let formattedPath = loc[loc.length - 1].replaceAll('-', ' ')
        setPath(formattedPath);
    }, [window.location.pathname])

    return (
        <div className={'w-screen bg-img'}>
            <div className={'font-m-plus md:container md:mx-auto p-10 md:px-56'}>
                <Header section={path.toUpperCase()} />
                {children}
                <Footer />
            </div>
        </div>
    );
}

export default Layout;